import { useAppShellChat } from '@/features/chat/useAppShellChat'
import { useProjectActions } from '@/features/chat/appShell/actions/useProjectActions.js'
import { usePulseNavBridge } from '@/features/pulsePanel/usePulseNavBridge'
import { useWhoami } from '@/hooks/useWhoami'
import { useAppShellLayoutHandlers } from './useAppShellLayoutHandlers.js'
import { buildAppShellSecondaryNavProps, resolveAppShellHomeNav } from './buildAppShellSecondaryNavProps.js'
import { useAppShellLayoutReturn } from './useAppShellLayoutReturn.js'
import { backendProjectsForNav, useBackendProjects } from './useBackendProjects.js'

export function useAppShellLayout() {
  const chat = useAppShellChat()
  const whoami = useWhoami()
  const backendProjects = useBackendProjects()
  const projectActions = useProjectActions({ setActiveProjectId: chat.setActiveProjectId })
  const shellNav = {
    navigate: chat.navigate,
    setSelectedThreadId: chat.setSelectedThreadId,
    setHomeView: chat.setHomeView,
    setHomeProduct: chat.setHomeProduct,
  }
  const handlers = useAppShellLayoutHandlers({
    location: chat.location,
    ...shellNav,
    setMainAskBarPrefill: chat.setMainAskBarPrefill,
  })
  usePulseNavBridge({ ...shellNav, prefillAskBar: chat.mainLayoutProps.onMainAskBarPrefill })
  const homeNav = resolveAppShellHomeNav({
    activePrimaryKey: chat.activePrimaryKey,
    threads: chat.threads,
    pinnedThreadIdsForNav: chat.pinnedThreadIdsForNav,
  })
  const secondaryNavProps = buildAppShellSecondaryNavProps({
    chat,
    handlers,
    session: whoami.data,
    projects: backendProjectsForNav(backendProjects),
    projectActions,
    ...homeNav,
  })
  return useAppShellLayoutReturn({
    chat,
    handlers,
    secondaryNavProps,
    projectDialog: projectActions.projectDialog,
  })
}
